import { migrateFeatures } from './migrateFeatures';
import { migrateFeaturesToPredictions } from './migrateFeaturesToPredictions';
import { migrateMediaToNewCollection } from './migrateMediaToNewCollection';
import { migrateSublocations } from './migrateSublocations';
import { featureConsolidation } from './featureConsolidation';
import { initializeFeatures } from './initializeFeatures';
import { setCategoryFeatures } from './setCategoryFeatures';

export const migrations = {
  migrateFeatures,
  migrateFeaturesToPredictions,
  migrateMediaToNewCollection,
  migrateSublocations,
  featureConsolidation,
  initializeFeatures,
  setCategoryFeatures
};

export const runMigration = async (migrationName) => {
  if (!migrations[migrationName]) {
    throw new Error(`Migration ${migrationName} not found`);
  }

  try {
    console.log(`Running migration: ${migrationName}`);
    await migrations[migrationName]();
    console.log(`Migration ${migrationName} completed successfully`);
  } catch (error) {
    console.error(`Migration ${migrationName} failed:`, error);
    throw error;
  }
};
